import React, { useContext, ReactNode } from 'react';
import { UserContext } from 'contexts/UserContext';
import { AppContext } from 'contexts/AppContext';
import { useFetchLease } from 'contexts/LeaseContext.hooks';

const DEFAULT_VALUE = {};

export const LeaseContext = React.createContext(DEFAULT_VALUE);

export const LeaseContextProvider = ({ children }: { children: ReactNode }) => {
  const { organizationId, propertyId } = useContext(AppContext);
  const { leaseId } = useContext(UserContext);

  const { data: lease } = useFetchLease({
    organizationId,
    propertyId,
    leaseId,
  });

  const value = {
    ...DEFAULT_VALUE,
    lease,
  };
  return (
    <LeaseContext.Provider value={value}>{children}</LeaseContext.Provider>
  );
};

export default { LeaseContextProvider, LeaseContext };
